export interface Action {
  type: string
  payload: any
}

enum ActionTypes {
  'SET_API_TOKEN' = 'SET_API_TOKEN',
  'SET_CALC_PROJECT' = 'SET_CALC_PROJECT',
  'RESET_APP' = 'RESET_APP',
}

export default ActionTypes
